export const SET_ADMINS = 'SET_ADMINS';
export const SET_ADMIN = 'SET_ADMIN';
export const ADD_ADMIN = 'ADD_ADMIN';
export const UPDATE_ADMIN = 'UPDATE_ADMIN';
export const REMOVE_ADMIN = 'REMOVE_ADMIN';
export const CLEAR_ADMIN = 'CLEAR_ADMIN';
export const CLEAR_ADMINS = 'CLEAR_ADMINS';
